module.exports = __webpack_public_path__ + "img/profile-black.0752b70b.svg";